import { call } from '../core'

export enum NotiResponseExposedTimeTASK {
  WRITE = 'write',
  READ = 'read',
}

/**
 * INotiResponseExposedTimeInfo
 *
 * value: 저장된 값 (알림 센터 진입시, 조회된 가장 최신 알림의 timestamp 값)
 */
interface INotiResponseExposedTimeInfo {
  value: number
}

/**
 * INotiResponseExposedTimeInfo
 *
 * task: preference 접근 타입 (write/read)
 */
interface INotiResponseExposedTimeParams {
  task: NotiResponseExposedTimeTASK
}

/**
 * IWriteParams
 *
 * task: write
 * value: 저장된 값 (알림 센터 진입시, 조회된 가장 최신 알림의 timestamp 값)
 */
export interface INotiResponseExposedTimeWriteParams extends INotiResponseExposedTimeParams {
  value: number
}

/**
 * IReadParams
 *
 * task: read
 */
export interface INotiResponseExposedTimeReadParams extends INotiResponseExposedTimeParams {}

export interface INotiResponseExposedTimeResult {
  result: INotiResponseExposedTimeInfo | null
}

export function notificationExposedTime(
  params: INotiResponseExposedTimeWriteParams | INotiResponseExposedTimeReadParams,
): Promise<INotiResponseExposedTimeResult | Error> {
  return call('finNotificationExposedTime', params)
}
